import { Spinner } from '@fluentui/react-components';
import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

const ProductLinePage = lazy(() =>
  import('../../pages/settings/product-line/ProductLinePage').then((m) => ({
    default: m.ProductLinePage,
  })),
);

export const Route = createFileRoute('/settings/product-line')({
  component: () => (
    <Suspense fallback={<Spinner style={{ position: 'absolute', top: '25%', left: '50%' }} />}>
      <ProductLinePage />
    </Suspense>
  ),
});
